import { render, staticRenderFns } from "./add-item-button.vue?vue&type=template&id=11165d29&scoped=true"
import script from "./add-item-button.vue?vue&type=script&lang=js"
export * from "./add-item-button.vue?vue&type=script&lang=js"
import style0 from "./add-item-button.vue?vue&type=style&index=0&id=11165d29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11165d29",
  null
  
)

export default component.exports